/* Cart drawer — AJAX add-to-cart + slide-out cart. Works site-wide (any {% form 'product' %}).
   Uses Shopify's Cart AJAX API + Section Rendering API so Liquid stays the source of truth
   (money formatting, selling-plan/subscription lines from Appstle, etc.). */
(function () {
  var SECTION = 'cart-drawer';
  var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  function url(path) { return root.replace(/\/$/, '') + path; }

  function getDrawerHost() { return document.getElementById('shopify-section-' + SECTION); }

  function openDrawer() { document.body.classList.add('cart-open'); }
  function closeDrawer() { document.body.classList.remove('cart-open'); }

  function setCount(n) {
    document.querySelectorAll('[data-cart-count]').forEach(function (el) {
      el.textContent = n;
      el.hidden = !n || n < 1;
      el.classList.toggle('is-empty', !n || n < 1);
    });
  }

  // Replace the drawer's rendered HTML from a Section Rendering API payload (full section markup).
  function swapSection(html) {
    var host = getDrawerHost();
    if (!host || !html) return;
    var tmp = document.createElement('div');
    tmp.innerHTML = html;
    // Shopify may return the section wrapped in #shopify-section-… or just its inner content.
    var wrapped = tmp.querySelector('#shopify-section-' + SECTION);
    host.innerHTML = wrapped ? wrapped.innerHTML : html;
  }

  // Shopify leaves the Shop Pay / Apple Pay / Google Pay buttons out of plain GET section renders in
  // browsers, but includes them in sections returned by Cart API mutations. Read first, and only when
  // the footer came back with an empty wallet slot re-render through an empty /cart/update.js (the slot
  // exists only for a non-empty cart, so this never creates a cart for a visitor who has none).
  function fetchSectionGet() {
    return fetch(url('/?sections=' + SECTION), { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (data) { return data && data[SECTION]; });
  }

  function fetchSectionViaUpdate() {
    return fetch(url('/cart/update.js'), {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ updates: {}, sections: SECTION })
    })
      .then(function (r) { return r.ok ? r.json() : Promise.reject(r); })
      .then(function (data) { return data && data.sections && data.sections[SECTION]; });
  }

  function walletSlotEmpty(html) {
    var tmp = document.createElement('div');
    tmp.innerHTML = html;
    var slot = tmp.querySelector('.cart-drawer__express');
    return !!slot && !slot.querySelector('shopify-accelerated-checkout-cart, [data-shopify="dynamic-checkout-cart"]');
  }

  function refreshFromCart() {
    return fetchSectionGet().then(function (html) {
      if (!html) return;
      if (!walletSlotEmpty(html)) { swapSection(html); return; }
      return fetchSectionViaUpdate()
        .then(function (withWallets) { swapSection(withWallets || html); })
        .catch(function () { swapSection(html); });
    });
  }

  /* A code that is on the cart but applies to nothing in it (15OFFLOVE is scoped to the
     single paks, so a cart of only Duo / Triple / Buy 3 Get 1 qualifies for nothing) comes
     back from /cart.js with applicable:false. Say so in the drawer; the line is hidden in
     the markup and shown here only in that case. */
  function updateCodeNote(c) {
    try {
      var note = document.querySelector('[data-codenote]');
      if (!note) { return; }
      var dead = (c && c.discount_codes || []).some(function (d) { return d && d.applicable === false; });
      note.hidden = !dead;
    } catch (e) { /* cosmetic only */ }
  }

  function syncCount() {
    return fetch(url('/cart.js'), { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (c) { setCount(c.item_count); updateCodeNote(c); return ensureOffer(c); })
      .catch(function () {});
  }

  /* ---- Pouch savings ladder: the cart always carries the right code ----
     One-time loose single paks: 1 = 15OFFLOVE, 2 = 20OFFLOVE, 3 or more = 25OFFLOVE.
     The three codes are scoped in Shopify to the two single-pak products (one-time
     only), so Duo / Triple / Buy 3 Get 1 / subscription lines never take them.

     This used to be an inline <script> inside the drawer section. A section that is
     re-rendered through innerHTML never runs its scripts, so after the first add the
     code only followed the cart on a full page load, and Checkout charged something
     different from what the drawer showed. It lives here now and runs after EVERY
     cart change (syncCount is the last step of every mutation) and on every page load.

     Rules:
     - A cart with a subscription line gets no ladder code (the codes combine with
       nothing, and the automatic 30% first-delivery discount must stay).
     - Any other code on the cart (a partner or landing-page code that works) is never
       replaced. A dead one (applicable:false) does not count.
     - If Shopify rejects the wanted code, the previous one is put back, the attempt is
       remembered for this cart (no retry loop) and the drawer explains it. */
  var OFFER = {
    singles: ['citrus-flower-blossom', 'dye-and-scent-free'],
    tiers: [{ min: 3, code: '25OFFLOVE' }, { min: 2, code: '20OFFLOVE' }, { min: 1, code: '15OFFLOVE' }]
  };
  var OFFER_CODES = OFFER.tiers.map(function (t) { return t.code; });
  var OFFER_RETRY = [0, 350, 800];       // ms before each attempt to put the code on
  var OFFER_FAIL_TTL = 120000;           // a definitive rejection is remembered for 2 minutes per cart state
  var offerBusy = null;
  var offerAgain = false;                // another cart change arrived while a sync was running

  function wait(ms) { return new Promise(function (r) { setTimeout(r, ms); }); }

  /* The two single-pak handles come from the drawer settings (rendered by the ladder snippet) so the
     Liquid ladder and this script can never disagree; the constants are only the fallback. */
  function offerSingles() {
    var el = document.querySelector('[data-offer-singles]');
    var list = el ? String(el.getAttribute('data-offer-singles')).split(',').map(function (x) { return x.trim(); }).filter(Boolean) : [];
    return list.length ? list : OFFER.singles;
  }

  function offerState(c) {
    var n = 0, plan = false, singles = offerSingles();
    (c.items || []).forEach(function (i) {
      if (i.selling_plan_allocation) { plan = true; }
      if (!((i.original_price || i.price) > 0) || singles.indexOf(i.handle) === -1 || i.selling_plan_allocation) { return; }
      n += i.quantity;
    });
    var wanted = '';
    /* A supporter cart (Loads of Love, built on /pages/support: cart attribute lol_support) never gets a ladder code,
       and one already on it is taken off. Read from the live cart, not from the page: it is what Checkout charges. */
    var supporter = !!(c.attributes && c.attributes.lol_support);
    /* The code is the BEST ONE STILL AVAILABLE for this quantity (window.LBOffer.pick): a returning customer (logged in,
       already ordered) and a visitor whose browser remembers a used code (cookie lb_used, set by the Customer events
       pixel) must not get a code Checkout would reject, so the cart shows the price Checkout will really charge. */
    if (!plan && n > 0 && !supporter) {
      if (window.LBOffer && typeof window.LBOffer.pick === 'function') {
        var pk = window.LBOffer.pick(n);
        if (pk >= 0) { wanted = ['15OFFLOVE', '20OFFLOVE', '25OFFLOVE'][pk]; }
      } else if (!(window.LB_OFFER && window.LB_OFFER.returning)) {
        for (var k = 0; k < OFFER.tiers.length; k++) { if (n >= OFFER.tiers[k].min) { wanted = OFFER.tiers[k].code; break; } }
      }
    }
    return { n: n, plan: plan, wanted: wanted };
  }

  function ladderCodeOf(c) {
    var found = null;
    (c.discount_codes || []).forEach(function (d) {
      var code = String(d && d.code || '').toUpperCase();
      if (OFFER_CODES.indexOf(code) !== -1 && !found) { found = { code: code, applicable: d.applicable !== false }; }
    });
    return found;
  }

  function otherLiveCode(c) {
    return (c.discount_codes || []).some(function (d) {
      var code = String(d && d.code || '').toUpperCase();
      return code && OFFER_CODES.indexOf(code) === -1 && d.applicable !== false;
    });
  }

  function onCartPage() { return window.location.pathname.replace(/\/$/, '') === url('/cart'); }

  function markOfferFailed(on) {
    document.querySelectorAll('[data-ladder-pending]').forEach(function (el) { el.hidden = !!on; });
    var note = document.querySelector('[data-codenote]');
    if (note && on) { note.hidden = false; }
  }

  /* Failures are remembered per cart state with a short life: a rejection that is only a hiccup
     must not switch the savings off for the rest of the session. */
  function offerFailSig(c, st) { return [c.token, st.wanted, st.n, st.plan ? 'p' : '-'].join('|'); }
  function offerFailed(sig) {
    try {
      var raw = JSON.parse(sessionStorage.getItem('lb-offer-fail') || 'null');
      return !!raw && raw.sig === sig && (Date.now() - raw.t) < OFFER_FAIL_TTL;
    } catch (e) { return false; }
  }
  function offerRemember(sig) { try { sessionStorage.setItem('lb-offer-fail', JSON.stringify({ sig: sig, t: Date.now() })); } catch (e) {} }
  function offerForget() { try { sessionStorage.removeItem('lb-offer-fail'); } catch (e) {} }

  function setLadderCode(code) {
    return postJSON('/cart/update.js', { discount: code, sections: SECTION, sections_url: window.location.pathname });
  }

  function showOfferResult(now) {
    if (now.sections && now.sections[SECTION]) { swapSection(now.sections[SECTION]); }
    if (typeof now.item_count === 'number') { setCount(now.item_count); }
    updateCodeNote(now);
  }

  /* One evaluation: compares what the cart carries with what its quantity earns and, if they differ,
     asks Shopify for the right code. A throttled or failed answer (429 / 5xx / network) is NOT a
     verdict and a code listed as not applicable right after an add can still settle, so every attempt
     is retried before anything is remembered or restored. */
  function offerStep(c) {
    var st = offerState(c);
    var cur = ladderCodeOf(c);
    var sig = offerFailSig(c, st);
    var none = { cart: c, changed: false };
    if (offerFailed(sig)) { markOfferFailed(true); return Promise.resolve(none); }
    if (otherLiveCode(c)) { return Promise.resolve(none); }
    var ok = (!st.wanted && !cur) || (st.wanted && cur && cur.code === st.wanted && cur.applicable);
    if (ok) { return Promise.resolve(none); }

    function attempt(i) {
      return wait(OFFER_RETRY[i]).then(function () { return setLadderCode(st.wanted); }).then(function (res) {
        var now = res.data || {};
        if (!res.ok) {
          return i + 1 < OFFER_RETRY.length ? attempt(i + 1) : { cart: c, changed: false, transient: true };
        }
        var back = ladderCodeOf(now);
        var applied = st.wanted ? !!(back && back.code === st.wanted && back.applicable) : !back;
        if (applied) { return { cart: now, changed: true }; }
        return i + 1 < OFFER_RETRY.length ? attempt(i + 1) : { cart: now, changed: false, rejected: true };
      });
    }
    return attempt(0).then(function (r) {
      if (r.changed) { offerForget(); showOfferResult(r.cart); return r; }
      if (r.rejected) {
        /* Definitive: put the previous live code back (or none) and say so. */
        offerRemember(sig);
        return setLadderCode(cur && cur.applicable ? cur.code : '').then(function (r2) {
          var d2 = r2.data || {};
          if (d2.items) { showOfferResult(d2); }
          markOfferFailed(true);
          return { cart: d2.items ? d2 : c, changed: false };
        });
      }
      return r;      // transient: no memo, no note, no restore; the next cart change or page load tries again
    });
  }

  /* Evaluate, apply, and look again while the cart keeps moving (a quick second tap on + / - while the
     first sync is in flight): at most three rounds. When more than one round ran, the drawer is
     rendered once more from the final cart so it can never show a stale intermediate state. */
  function offerLoop(c, round) {
    return offerStep(c).then(function (r) {
      var again = offerAgain;
      offerAgain = false;
      if ((r.changed || again) && round < 2) {
        return getCart().then(function (c2) {
          return offerLoop(c2, round + 1).then(function (r2) { return { cart: r2.cart, changed: r.changed || r2.changed }; });
        });
      }
      if (round > 0 && (r.changed || again)) { return refreshFromCart().then(function () { return r; }); }
      return r;
    });
  }

  function ensureOffer(c) {
    if (!c || !c.items || window.LB_OFFER_SYNC === false) { return Promise.resolve(c); }
    /* An emptied supporter cart is not a supporter order any more: whoever shops normally next must get the ladder. */
    if (!c.items.length && c.attributes && c.attributes.lol_support) {
      postJSON('/cart/update.js', { attributes: { lol_support: '' } }).catch(function () {});
    }
    if (offerBusy) { offerAgain = true; return offerBusy; }
    offerBusy = offerLoop(c, 0).then(function (r) {
      if (r.changed && onCartPage()) { window.location.reload(); }
      return r.cart || c;
    }).catch(function () { return c; }).then(function (out) { offerBusy = null; offerAgain = false; return out; });
    return offerBusy;
  }

  /* /cart page: the quantities and the Checkout button are one native form, so editing a quantity and
     pressing Checkout (instead of "Update cart") used to reach Checkout with the PREVIOUS code. Checkout
     now first saves the quantities and the note, puts the right code on, and only then goes on. */
  document.addEventListener('click', function (e) {
    var b = e.target.closest && e.target.closest('form[action$="/cart"] [name="checkout"]');
    if (!b || !b.form || window.LB_OFFER_SYNC === false) { return; }
    e.preventDefault();
    if (b.getAttribute('aria-busy') === 'true') { return; }
    b.setAttribute('aria-busy', 'true');
    var form = b.form;
    var updates = Array.prototype.map.call(form.querySelectorAll('input[name="updates[]"]'), function (i) { return parseInt(i.value, 10) || 0; });
    var body = {};
    if (updates.length) { body.updates = updates; }
    var noteEl = form.querySelector('[name="note"]');
    if (noteEl) { body.note = noteEl.value; }
    var go = function () { window.location.href = url('/checkout'); };
    postJSON('/cart/update.js', body)
      .then(function () { return getCart(); })
      .then(function (c) { var ps = offerState(c); return ps.n || ps.plan || ladderCodeOf(c) ? ensureOffer(c) : c; })
      .then(go, go);
  });

  /* Un solo sitio en el tema sabe si un alta termino bien; el resto se entera
     por este evento en vez de volver a interceptar el formulario. `variantId`
     puede faltar (Shopify responde distinto segun la forma del alta) y quien
     escuche tiene que saber apanarselas sin el. */
  function anunciarAlta(data) {
    var vid = null;
    if (data) {
      if (data.id) { vid = data.id; }
      else if (data.items && data.items.length) { vid = data.items[0].id; }
    }
    document.dispatchEvent(new CustomEvent('lb:cart:added', { detail: { variantId: vid } }));
  }


  /* Un fallo al añadir se cuenta DENTRO del cajón, no con un alert() del
     navegador: un diálogo nativo a mitad de una compra corta el flujo y en
     una landing de pago se lleva la conversión por delante.
     El error completo queda en consola para poder diagnosticarlo después. */
  function showCartError(res, contexto) {
    var msg = (res && res.data && (res.data.description || res.data.message)) ||
              'We could not add this item. Please try again.';
    try {
      console.error('[cart] alta fallida (' + contexto + ')', {
        status: res && res.status,
        shopify: res && res.data,
        url: window.location.href
      });
    } catch (e) {}

    openDrawer();
    var host = getDrawerHost();
    var panel = host && host.querySelector('.cart-drawer__panel');
    var mount = panel || host;
    if (!mount) { return; }

    var old = mount.querySelector('[data-cart-error]');
    if (old) { old.remove(); }

    var box = document.createElement('div');
    box.setAttribute('data-cart-error', '');
    box.setAttribute('role', 'alert');
    box.style.cssText = 'margin:12px;padding:12px 14px;border:1px solid #f0c9c1;' +
      'background:#fbeeea;color:#8c2f22;border-radius:10px;font-size:.9rem;line-height:1.45';
    box.textContent = msg;
    mount.insertBefore(box, mount.firstChild);
    /* se va sola: no debe quedarse pegada cuando el cliente reintenta */
    setTimeout(function () { if (box.parentNode) { box.remove(); } }, 8000);
  }

  /* Shopify instrumenta el alta al carrito por DOS caminos: envuelve `fetch`
     y ademas engancha un `submit` SOBRE el propio <form action="/cart/add">.
     Ese segundo camino solo se calla si el evento ya llega con
     defaultPrevented. Nuestro interceptor de abajo esta delegado en
     `document` (burbuja) y, por orden de despacho del DOM, corre DESPUES del
     listener que Shopify pone en el form — asi que Shopify publicaba un
     `product_added_to_cart` de mas y Meta contaba DOS AddToCart por una sola
     peticion a /cart/add.js. Medido en vivo: 1 POST, 2 eventos, eventID
     distintos (o sea, no es la deduplicacion de la CAPI).

     Esto lo apaga en CAPTURA, antes de que corra el de Shopify. Queda solo el
     evento de la via `fetch`, que es el bueno: sale del carrito de verdad y no
     de una estimacion leida del formulario.

     OJO: no mover el listener de abajo a captura. Correria antes que los
     handlers propios de las landings de pago (lp-buy, lp-single, fast-figma-
     hero...) y alli si se anadiria dos veces al carrito. */
  document.addEventListener('submit', function (e) {
    var fAdd = e.target.closest && e.target.closest('form[action*="/cart/add"]');
    if (fAdd) e.preventDefault();
  }, true);

  // ---- Add to cart (intercept every product form) ----
  document.addEventListener('submit', function (e) {
    var form = e.target.closest && e.target.closest('form[action*="/cart/add"]');
    if (!form) return;
    e.preventDefault();

    var btn = form.querySelector('[name="add"]');
    if (btn) { btn.classList.add('is-loading'); btn.setAttribute('aria-busy', 'true'); btn.disabled = true; }

    var added = null;
    var fd = new FormData(form);
    fd.append('sections', SECTION);
    fd.append('sections_url', window.location.pathname);

    fetch(url('/cart/add.js'), { method: 'POST', headers: { 'Accept': 'application/json' }, body: fd })
      .then(function (r) { return r.json().then(function (data) { return { ok: r.ok, status: r.status, data: data }; }); })
      .then(function (res) {
        if (!res.ok) {
          showCartError(res, 'formulario de producto');
          return;
        }
        added = res.data;
        if (res.data.sections && res.data.sections[SECTION]) {
          swapSection(res.data.sections[SECTION]);
        } else {
          return refreshFromCart();
        }
      })
      .then(function () { return syncCount(); })
      .then(function () { openDrawer(); anunciarAlta(added); })
      .catch(function (err) { console.error('[cart] add failed', err); })
      .finally(function () {
        if (btn) { btn.classList.remove('is-loading'); btn.removeAttribute('aria-busy'); btn.disabled = false; }
      });
  });

  /* ---- One-tap bundle upgrade ----
     Swaps the single paks in the cart for the bundle of the same scent. The
     button carries the bundle variant (data-upgrade-add) and a plan
     "variantId=paksLeft|variantId=paksLeft" (data-upgrade-lines): how many
     ONE-TIME units of each variant may stay once the bundle is in (0 for a
     plain swap). Both are rendered by Liquid from the cart on screen.

     - The bundle is added FIRST; the old lines are reduced only once that
       worked, so a sold-out or failed add leaves the cart as it was (and a
       discount code like 15OFFLOVE never sees an empty cart and drops off).
     - Lines are found again in every fresh cart response, by variant, one-time
       only (no selling plan, price above zero). Line keys are NOT reused: in
       this store a key changes whenever a discount code is re-allocated
       across the lines, which adding the bundle can do. Subscription lines of the same variant and
       the $0 gift are never touched, and a quantity is never raised.
     - Each change asks for the drawer section, so the re-render comes from a
       Cart API mutation and keeps its wallet buttons; refreshFromCart() is the
       fallback, as everywhere else.
     - Deliberately NOT announced as lb:cart:added: that event opens the
       subscription pop-up, and a bundle has no subscription to offer. */
  function postJSON(path, payload) {
    return fetch(url(path), {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify(payload)
    }).then(function (r) {
      return r.json().catch(function () { return {}; }).then(function (d) { return { ok: r.ok, status: r.status, data: d }; });
    });
  }

  function getCart() {
    return fetch(url('/cart.js'), { headers: { 'Accept': 'application/json' } }).then(function (r) { return r.json(); });
  }

  function parsePlan(raw) {
    var seen = {};
    return String(raw || '').split('|').map(function (pair) {
      var bits = pair.split('=');
      var vid = parseInt(bits[0], 10);
      var keep = parseInt(bits[1], 10);
      if (!vid || isNaN(keep) || seen[vid]) { return null; }
      seen[vid] = true;
      return { variantId: vid, keep: Math.max(0, keep) };
    }).filter(Boolean);
  }

  /* Next single change that brings the cart closer to the plan, or null. */
  function nextPlanStep(items, plan) {
    for (var p = 0; p < plan.length; p++) {
      var lines = (items || []).filter(function (i) {
        return i.variant_id === plan[p].variantId && !i.selling_plan_allocation && (i.original_price || i.price) > 0;
      });
      var total = lines.reduce(function (n, i) { return n + i.quantity; }, 0);
      if (total > plan[p].keep) {
        var line = lines[lines.length - 1];
        return { id: line.key, quantity: Math.max(0, line.quantity - (total - plan[p].keep)) };
      }
    }
    return null;
  }

  /* Applies the plan one change at a time, re-reading the cart from every
     response. Resolves with the last drawer HTML returned, if any. */
  function applyPlan(items, plan) {
    var html = null;
    var guard = 0;
    function loop(current) {
      var step = nextPlanStep(current, plan);
      if (!step || ++guard > 8) { return Promise.resolve(html); }
      step.sections = SECTION;
      step.sections_url = window.location.pathname;
      return postJSON('/cart/change.js', step).then(function (r) {
        if (!r.ok) { throw { cartRes: r }; }
        if (r.data && r.data.sections && r.data.sections[SECTION]) { html = r.data.sections[SECTION]; }
        return loop(r.data && r.data.items);
      });
    }
    return loop(items);
  }

  /* Another script writing to the cart at the same moment (the gift rule adds
     its line ~250 ms after an add on the gift landings; a drawer refresh posts
     an empty /cart/update.js) can overwrite the swap with a cart it read just
     before: last write wins. So the cart is read back once more and anything
     that did not stick is replayed. Resolves true when something was replayed,
     so the caller re-renders from the confirmed cart. */
  function verifySwap(addId, plan) {
    return new Promise(function (r) { setTimeout(r, 400); })
      .then(getCart)
      .then(function (c) {
        var items = (c && c.items) || [];
        var hasBundle = items.some(function (i) { return i.variant_id === addId; });
        var needsPlan = !!nextPlanStep(items, plan);
        if (hasBundle && !needsPlan) { return false; }
        console.warn('[cart] upgrade: replaying a step that did not stick', { bundle: hasBundle, lines: needsPlan });
        /* If the bundle cannot be put back (sold out in between), the old
           lines are NOT reduced: a cart that lost both would be worse than a
           cart that still holds the single paks. */
        var chain = hasBundle ? Promise.resolve(items)
          : postJSON('/cart/add.js', { items: [{ id: addId, quantity: 1 }] }).then(function (r) {
              return r.ok ? getCart().then(function (c2) { return c2.items; }) : null;
            });
        return chain.then(function (now) { return now ? applyPlan(now, plan) : null; }).then(function () { return true; });
      })
      /* A failed read-back must not turn a good swap into an error message. */
      .catch(function () { return false; });
  }

  /* One swap at a time. The panel lock alone is not enough: the drawer is
     re-rendered (unlocked) before the read-back in verifySwap() finishes. */
  var upgrading = false;

  function upgradeLine(btn) {
    var panel = btn.closest('.cart-drawer__panel');
    if (upgrading || btn.getAttribute('aria-busy') === 'true' || (panel && panel.classList.contains('is-busy'))) { return; }
    var addId = parseInt(btn.getAttribute('data-upgrade-add'), 10);
    var plan = parsePlan(btn.getAttribute('data-upgrade-lines'));
    if (!addId || !plan.length) { return; }

    upgrading = true;
    btn.setAttribute('aria-busy', 'true');
    if (panel) { panel.classList.add('is-busy'); }
    var stage = 'add';
    var html = null;
    var changeErr = null;

    postJSON('/cart/add.js', { items: [{ id: addId, quantity: 1 }] })
      .then(function (res) {
        if (!res.ok) {
          stage = 'failed';
          showCartError(res, 'mejora a pack');
          return null;
        }
        stage = 'change';
        return getCart()
          .then(function (c) { return applyPlan(c.items, plan); })
          .then(function (h) { html = h; })
          .then(function () { return verifySwap(addId, plan); })
          .then(function (replayed) { if (replayed) { html = null; } });
      })
      .catch(function (err) {
        /* The bundle is in but an old line could not be changed. The real cart
           is re-rendered below (both lines visible) so the shopper can remove
           the extra one, and the message is shown AFTER that re-render, which
           would otherwise wipe it. */
        console.error('[cart] upgrade failed at ' + stage, err);
        html = null;
        changeErr = (err && err.cartRes) || { data: { description: 'We could not finish the swap. Please check your cart.' } };
      })
      .then(function () {
        if (stage === 'failed') { return null; }
        if (html) { swapSection(html); return null; }
        return refreshFromCart();
      })
      .then(function () { if (changeErr) { showCartError(changeErr, 'mejora a pack: cambio de linea'); } })
      .then(function () { return syncCount(); })
      .then(function () {
        if (stage === 'change' && !changeErr) {
          document.dispatchEvent(new CustomEvent('lb:cart:upgraded', { detail: {
            variantId: addId,
            fromPaks: parseInt(btn.getAttribute('data-upgrade-from'), 10) || null,
            toPaks: parseInt(btn.getAttribute('data-upgrade-to'), 10) || null
          } }));
        }
      })
      .catch(function (err) { console.error('[cart] upgrade refresh failed', err); })
      .then(function () {
        /* After a re-render the old panel and button are gone; this only
           matters when nothing was swapped and the same nodes are on screen. */
        var p = document.querySelector('.cart-drawer__panel.is-busy');
        if (p) { p.classList.remove('is-busy'); }
        if (btn.isConnected) { btn.removeAttribute('aria-busy'); }
        upgrading = false;
      });
  }

  /* Add one or more variants in a single request and show the drawer. Used by the
     product page and the shop page for "both scents" (1 Citrus + 1 Dye), which a normal
     product form cannot express, and by the ladder's "Add 1 more pak" button. The
     savings code is attached by syncCount() -> ensureOffer() like after any other add. */
  var addingNow = null;
  function addItems(items, opts) {
    opts = opts || {};
    if (addingNow) { return addingNow; }
    addingNow = postJSON('/cart/add.js', { items: items, sections: SECTION, sections_url: window.location.pathname })
      .then(function (res) {
        if (!res.ok) { showCartError(res, opts.context || 'alta multiple'); return null; }
        if (res.data && res.data.sections && res.data.sections[SECTION]) { swapSection(res.data.sections[SECTION]); }
        else { return refreshFromCart().then(function () { return res.data; }); }
        return res.data;
      })
      .then(function (data) { return syncCount().then(function () { return data; }); })
      .then(function (data) {
        if (data) { openDrawer(); if (opts.announce !== false) { anunciarAlta(data); } }
        return data;
      })
      .catch(function (err) { console.error('[cart] addItems failed', err); return null; })
      .then(function (out) { addingNow = null; return out; });
    return addingNow;
  }

  // ---- Drawer interactions (delegated, survive innerHTML swaps) ----
  document.addEventListener('click', function (e) {
    // open from header cart icon / any [data-cart-toggle]
    var toggle = e.target.closest && e.target.closest('[data-cart-toggle]');
    if (toggle) {
      e.preventDefault();
      openDrawer();
      refreshFromCart().then(syncCount);
      return;
    }

    // close
    if (e.target.closest && e.target.closest('[data-cart-close]')) {
      e.preventDefault();
      closeDrawer();
      return;
    }

    // one-tap "add 1 more pak" (snippets/cart-pak-ladder.liquid)
    var more = e.target.closest && e.target.closest('[data-cart-addone]');
    if (more) {
      e.preventDefault();
      var vid = parseInt(more.getAttribute('data-cart-addone'), 10);
      if (!vid || more.getAttribute('aria-busy') === 'true') { return; }
      more.setAttribute('aria-busy', 'true');
      var pnl = more.closest('.cart-drawer__panel');
      if (pnl) { pnl.classList.add('is-busy'); }
      addItems([{ id: vid, quantity: 1 }], { announce: false, context: 'un pak mas' }).then(function () {
        var p2 = document.querySelector('.cart-drawer__panel.is-busy');
        if (p2) { p2.classList.remove('is-busy'); }
        if (more.isConnected) { more.removeAttribute('aria-busy'); }
      });
      return;
    }

    // one-tap bundle upgrade (old carts only; the ladder no longer renders these buttons)
    var upg = e.target.closest && e.target.closest('[data-cart-upgrade]');
    if (upg) {
      e.preventDefault();
      upgradeLine(upg);
      return;
    }

    // quantity change / remove
    var qbtn = e.target.closest && e.target.closest('[data-cart-qty]');
    if (qbtn) {
      var line = qbtn.closest('[data-cart-line]');
      if (!line) return;
      var body = qbtn.closest('.cart-drawer__panel');
      if (body) body.classList.add('is-busy');
      var payload = { line: parseInt(line.getAttribute('data-cart-line'), 10), quantity: parseInt(qbtn.getAttribute('data-cart-qty'), 10), sections: SECTION, sections_url: window.location.pathname };
      fetch(url('/cart/change.js'), {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify(payload)
      })
        .then(function (r) { return r.json(); })
        .then(function (data) {
          if (data.sections && data.sections[SECTION]) swapSection(data.sections[SECTION]);
          else return refreshFromCart();
          setCount(data.item_count);
        })
        .then(function () { return syncCount(); })
        .catch(function (err) { console.error('[cart] change failed', err); });
    }
  });

  // Esc closes
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeDrawer(); });

  // Keep the count badge correct on load
  document.addEventListener('DOMContentLoaded', syncCount);

  /* Superficie minima para que otras piezas del tema usen ESTE drawer en vez de
     reimplementarlo o mandar a la pagina de carrito. */
  window.LBCart = {
    open: openDrawer,
    close: closeDrawer,
    refresh: function () { return refreshFromCart().then(syncCount); },
    syncCount: syncCount,
    addItems: addItems,
    ensureOffer: function () { return getCart().then(ensureOffer); },
  };
})();
